// extracted by mini-css-extract-plugin
export default {"slideWrapper":"PhotoSlider_slideWrapper__sn6oa","mirrorBackground":"PhotoSlider_mirrorBackground__-KiJk","mainImage":"PhotoSlider_mainImage__szHDH"};